import y, { useRef as N, useState as B, useEffect as I } from "react";
import { clsx as U } from "../../../clsx/dist/clsx.js";
import P from "../../../react-smooth/es6/Animate.js";
import { filterProps as j } from "../util/ReactUtils.js";
function h(e) {
  "@babel/helpers - typeof";
  return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, h(e);
}
function g() {
  return g = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, g.apply(this, arguments);
}
function R(e, r) {
  return M(e) || K(e, r) || H(e, r) || C();
}
function C() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function H(e, r) {
  if (e) {
    if (typeof e == "string") return A(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return A(e, r);
  }
}
function A(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++) n[t] = e[t];
  return n;
}
function K(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var n, o, u, a, i = [], c = !0, l = !1;
    try {
      if (u = (t = t.call(e)).next, r !== 0) for (; !(c = (n = u.call(t)).done) && (i.push(n.value), i.length !== r); c = !0) ;
    } catch (f) {
      l = !0, o = f;
    } finally {
      try {
        if (!c && t.return != null && (a = t.return(), Object(a) !== a)) return;
      } finally {
        if (l) throw o;
      }
    }
    return i;
  }
}
function M(e) {
  if (Array.isArray(e)) return e;
}
function S(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function E(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? S(Object(t), !0).forEach(function(n) {
      G(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : S(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function G(e, r, t) {
  return r = X(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function X(e) {
  var r = Y(e, "string");
  return h(r) == "symbol" ? r : r + "";
}
function Y(e, r) {
  if (h(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(e, r);
    if (h(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
var T = function(r, t, n, o, u) {
  var a = n - o, i;
  return i = "M ".concat(r, ",").concat(t), i += "L ".concat(r + n, ",").concat(t), i += "L ".concat(r + n - a / 2, ",").concat(t + u), i += "L ".concat(r + n - a / 2 - o, ",").concat(t + u), i += "L ".concat(r, ",").concat(t, " Z"), i;
}, Z = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, Q = function(r) {
  var t = E(E({}, Z), r), n = N(), o = B(-1), u = R(o, 2), a = u[0], i = u[1];
  I(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var s = n.current.getTotalLength();
        s && i(s);
      } catch {
      }
  }, []);
  var c = t.x, l = t.y, f = t.upperWidth, m = t.lowerWidth, p = t.height, _ = t.className, b = t.animationEasing, d = t.animationDuration, W = t.animationBegin, v = t.isUpdateAnimationActive;
  if (c !== +c || l !== +l || f !== +f || m !== +m || p !== +p || f === 0 && m === 0 || p === 0)
    return null;
  var O = U("recharts-trapezoid", _);
  return v ? /* @__PURE__ */ y.createElement(P, {
    canBegin: a > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: p,
      x: c,
      y: l
    },
    to: {
      upperWidth: f,
      lowerWidth: m,
      height: p,
      x: c,
      y: l
    },
    duration: d,
    animationEasing: b,
    isActive: v
  }, function(s) {
    var w = s.upperWidth, x = s.lowerWidth, L = s.height, D = s.x, z = s.y;
    return /* @__PURE__ */ y.createElement(P, {
      canBegin: a > 0,
      from: "0px ".concat(a === -1 ? 1 : a, "px"),
      to: "".concat(a, "px 0px"),
      attributeName: "strokeDasharray",
      begin: W,
      duration: d,
      easing: b
    }, /* @__PURE__ */ y.createElement("path", g({}, j(t, !0), {
      className: O,
      d: T(D, z, w, x, L),
      ref: n
    })));
  }) : /* @__PURE__ */ y.createElement("g", null, /* @__PURE__ */ y.createElement("path", g({}, j(t, !0), {
    className: O,
    d: T(c, l, f, m, p)
  })));
};
export {
  Q as Trapezoid
};
